/* eslint-disable @trello/disallow-filenames */
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { stickerMargin } from 'app/scripts/data/sticker-margin';

const minValue = -stickerMargin;
const maxValue = 100 - stickerMargin;

// Used to ensure that a sticker is inside the editable area
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const stickerClip = function (value: any) {
  if (value < minValue) {
    return minValue;
  } else if (value > maxValue) {
    return maxValue;
  } else {
    return value;
  }
};
